import buttonsMenu from './buttonsmenu.module.css'
const ButtonsMenu = ({ btns }) => {
  return (
    <div
      className={buttonsMenu.buttonscontainer}
    >
    {(btns && btns.length > 0) ? btns.map(([ title, height, logo, method], index) => {
        const column = index+1
        return(
        <input
          key={title+index}
          type="image"
          src={logo}
          title={title}
          onClick={method}
          className={buttonsMenu.button}
          style={{
             gridColumn:{column},
             height:height+"px",
          }}
          alt={title}
        />)
      }):<h1>الجامعة الوطنية الخاصة</h1>}
    </div>
  );
};
 export default ButtonsMenu